import { makeStyles } from '@material-ui/core/styles';
import { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { color } from './app/theme';
import Header from './components/gss/Header';
import Initial from './components/gss/Initial';
import Setting from './components/gss/Setting';
import Loading from './components/Loading';

const useStyles = makeStyles(
  () => ({
    root: {
      height: 'calc(100vh - 80px)',
    },
    main: {
      width: 'calc(100% - 240px)',
      height: 'calc(100vh - 80px)',
      backgroundColor: color.$7,
      padding: '44px 44px 96px 44px',
      margin: '80px 320px 0 240px',
      overflow: 'auto',
    },
    noSidebar: {
      width: '100%',
      height: 'calc(100vh - 80px)',
      backgroundColor: color.$7,
      padding: '44px 44px 96px 44px',
      margin: '80px 0 0 0',
      overflow: 'auto',
    },
    loading: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
    },
  }),
  {
    name: 'MitakeRoute',
  },
);

function MitakeRoute() {
  const classes = useStyles();

  return (
    <Switch>
      <Route path="/gssVital">
        <Route path="/gssVital/:orgId">
          <div className={classes.root}>
            <Header />
            <Initial />
            <Suspense fallback={<Loading />}>
              <Switch>
                <Route exact path="/gssVital/:orgId/setting">
                  <main id="App-main" className={classes.noSidebar}>
                    <Setting />
                  </main>
                </Route>
              </Switch>
            </Suspense>
          </div>
        </Route>
      </Route>
    </Switch>
  );
}

export default MitakeRoute;
